import type { FeeCalcInput, GuaranteeDebtor, GuaranteeInput, WorkRateInput } from "@juro/shared";
import { expectedScheduleKind, type FeeScheduleDocType } from "@juro/shared";

/** 空の作業行計算入力（土地計算書・建物計算書） */
export function emptyWorkRateInput(): WorkRateInput {
  return {
    kind: "work_rate",
    rows: [],
    travel_km: 0,
    adjustment_amount: 0,
    registration_tax_amount: 0,
    advance_expense_amount: 0,
    prepaid_amount: 0,
    apply_withholding: false,
  };
}

/**
 * 空の債務者行（保証協会請求書）。
 * has_base_fee は false から始める: 現行Excelも「E列（基本報酬等）に値を入れた債務者だけ
 * 基本報酬が立つ」挙動であり、true 始まりだと空の新規書類に幽霊の基本報酬13,200が計上される。
 */
export function emptyGuaranteeDebtor(): GuaranteeDebtor {
  return {
    name: "",
    transfer_amount: 0,
    has_base_fee: false,
    inspection_count: 0,
    count_surcharge: 0,
    transcript_count: 0,
    transcript_tax_count: 0,
    per_diem: 0,
    travel: 0,
  };
}

/** 空の保証協会計算入力（債務者1行つき） */
export function emptyGuaranteeInput(): GuaranteeInput {
  return {
    kind: "guarantee",
    debtors: [emptyGuaranteeDebtor()],
    advance_paid_amount: 0,
  };
}

/** 書類種別に応じた空の calc_input（新規作成・calc_input 未保存の既存 draft 用） */
export function emptyFeeCalcInput(docType: FeeScheduleDocType): FeeCalcInput {
  return expectedScheduleKind(docType) === "guarantee"
    ? emptyGuaranteeInput()
    : emptyWorkRateInput();
}
